module.exports = __webpack_public_path__ + "static/media/azureAD.d14ef7ed.svg";